/* @flow */
import API from 'lib/RemindAPI';
import { QUERY } from './OrganizationPicker';
import type { Organization, SearchOptions, OrganizationSearch } from './types'; // eslint-disable-line
import { getApolloClientSingleton } from 'lib/apollo/client/browser';

const searchOrganizations: OrganizationSearch = async options => {
  const queryOptions = {
    page: 1,
    per_page: 20,
    ...options,
  };

  const organizations: Array<Organization> = await API.request(
    '/organizations/find',
    'GET',
    queryOptions
  );

  try {
    // Write the cache, this a "nice to have",
    // since it saves request and avoid displaying a loading indicator.
    // In try catch block because it's totally optional.
    organizations.forEach(organization => {
      getApolloClientSingleton().writeQuery({
        query: QUERY,
        variables: { uuid: organization.uuid },
        data: {
          organizations: [
            {
              __typename: 'Organization',
              id: organization.id,
              uuid: organization.uuid,
              name: organization.name,
              city: organization.city,
              state: organization.state,
              members_sample_string: organization.members_sample_string,
            },
          ],
        },
      });
    });
  } catch (e) {
    console.debug(e, e && e.stack);
    console.error('OrganizationPicker - could not write cache');
  }

  return organizations;
};

export default searchOrganizations;
